import axios from 'axios'
import { onSuccess, onError, beforeRequestSuccess, beforeRequestError } from './interceptors'

const routingClient = axios.create({
  baseURL: process.env.ROUTING_API,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

routingClient.interceptors.request.use(beforeRequestSuccess, beforeRequestError)

routingClient.interceptors.response.use(onSuccess, onError)

export let client = routingClient



// WEBPACK FOOTER //
// ./src/api/routing/client.js